const SUB_PATH_TYPES = {
  IN: "In",
  OUT: "Out",
};

module.exports = {
  SUB_PATH_TYPES,
};
